import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DividerModule } from "primeng/divider";
import { SkeletonModule } from "primeng/skeleton";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SharedRoutingModule } from './shared-routing.module';
import { LoadingComponent } from './components/loading/loading.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SearchBoxFilterComponent } from './components/search-box-filter/search-box-filter.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { OpenBatchModalComponent } from './components/open-batch-modal/open-batch-modal.component';
import { DeleteCommonModalComponent } from './components/delete-common-modal/delete-common-modal.component';
import { EditTpnOpenBatchModalComponent } from './components/edit-tpn-open-batch-modal/edit-tpn-open-batch-modal.component';
import { InformationModalComponent } from './components/information-modal/information-modal.component';
import { JumpToButtonsComponentComponent } from './components/jump-to-buttons-component/jump-to-buttons-component.component';
import { LoginAsModalComponent } from './components/login-as-modal/login-as-modal.component';
import { DynamicFormComponentComponent } from './components/dynamic-form-component/dynamic-form-component.component';
import {InputNumberModule} from 'primeng/inputnumber';
import { ToastModule } from 'primeng/toast';
import { DownloaderLoaderComponent } from './components/downloader-loader/downloader-loader.component';
import { SetUpRecurringPaymentFormComponent } from './components/set-up-recurring-payment-form/set-up-recurring-payment-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { IsoLogoUploadComponent } from './components/iso-logo-upload/iso-logo-upload.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { RefreshButtonComponent } from './components/refresh-button/refresh-button.component';
import { SelectButtonModule } from "primeng/selectbutton";
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from "primeng/checkbox";
import { FileUploadModule } from "primeng/fileupload";
import { FieldsetModule } from "primeng/fieldset";
import { RadioButtonModule } from "primeng/radiobutton";
import { UiSwitchModule } from "ngx-ui-switch";
import { CapitalizePipe } from 'src/app/pipe/capitalize.pipe';
import { HelperTooltipComponent } from './components/helper-tooltip/helper-tooltip.component';
import { ProcessorDataFormComponentComponent } from './components/Processordata-form-component/Processordata-form-component.component';
import { ArrayToValues, ValueOrNaPipe } from 'src/app/pipe/value-or-na.pipe';
import { AchProcessorDataComponent } from './components/ach-processor-data/ach-processor-data.component';
import { ReactiveFormDynamicErrorMessageComponent } from './components/reactive-form-dynamic-error-message/reactive-form-dynamic-error-message.component';
import { AppTwoDIgitDecimalNumberDirective } from '../core/directive/app-two-digit-decimal-number.directive';
import { ToAmountPipe, ToDollarsPipe, DollarsToCents } from '../pipe/to-dollars/to-dollars.pipe';
import { MessageModule } from 'primeng/message';
import { DropdownModule } from 'primeng/dropdown';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { RibbonComponent } from './ribbon/ribbon.component';
import { datePipeModule } from 'src/app/shared/pipe/datePipe.module';
import { IntegerOnlyDirective } from '../core/directive/integer-only.directive';
import {ListboxModule} from 'primeng/listbox';
import {ButtonModule} from 'primeng/button';
import { IlustrationWithMessageComponent } from './components/ilustration-with-message/ilustration-with-message.component';
import { SanitizerUrlPipe } from './pipe/safe-url.pipe';
import { TransactionDataPipe } from './pipe/transaction-data.pipe';
import { ZipCodeComponent } from './components/zip-code/zip-code.component';
import { TableModule } from 'primeng/table';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { AccordionModule } from "primeng/accordion";
import { CardComponent } from './components/card/card.component';
import { CardModalWidgetComponent } from './components/card-modal-widget/card-modal-widget.component';
import { ZingchartAngularModule } from 'zingchart-angular';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { CustomSelectFilterComponent } from './components/custom-select-filter/custom-select-filter.component'
import { ChipsModule } from 'primeng/chips';
import { WoocommerceSettingsComponent } from './components/woocommerce-settings/woocommerce-settings.component';
import { MessageService } from 'primeng/api';
import { InputSwitchModule } from 'primeng/inputswitch';
import { EmailChangeModalComponent } from './components/email-change-modal/email-change-modal.component'
import { TermsAndconditionComponent } from '../views/pages/terms-condition/terms-condition.component';
import { AutoScrollbarHeightDirective } from '../core/directive/auto-scrollbar-height.directive';
import { ZipFormatDirective } from '../core/directive/zip-format.directive';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { MerchantBillingDialogComponent } from './components/merchant-billing-dialog/merchant-billing-dialog.component';
import { PayaAchComponent } from '../views/pages/virtual-terminal/paya-ach/paya-ach.component';
import { PaymentStatusComponent } from '../views/pages/virtual-terminal/payment-status/payment-status.component';
import { MultiFactorAuthComponent } from '../views/pages/auth/multi-factor-auth/multi-factor-auth.component';
import { HighlightPipe } from '../pipe/highlight.pipe';
import { DynamicFormGroupComponent } from './components/dynamic-form-group/dynamic-form-group.component';
import { NotesComponent } from './components/notes/notes.component';
import { InventoryRegisterLiteSettingsComponent } from './inventory-register-lite-settings/inventory-register-lite-settings.component';
import { TooltipModule } from 'primeng/tooltip';
import { VericheckAchComponent } from '../views/pages/virtual-terminal/vericheck-ach/vericheck-ach.component';
import { IsvApplicationDialogComponent } from './components/isv-application-dialog/isv-application-dialog.component';
import { IsvTagDialogComponent } from './components/isv-tag-dialog/isv-tag-dialog.component';
import { FileDropzoneComponent } from './components/file-dropzone/file-dropzone.component';
import { PageBreadcrumbComponent } from './components/page-breadcrumb/page-breadcrumb.component';
import { FileStatusModalComponent } from './components/file-status-modal/file-status-modal.component';
import { ToastProgressComponent } from './components/toast-progress/toast-progress.component';
import { ProgressBarModule } from 'primeng/progressbar';
@NgModule({
  declarations: [
    LoadingComponent, DashboardComponent, SearchBoxFilterComponent, ConfirmationDialogComponent, SafeHtmlPipe, OpenBatchModalComponent, DeleteCommonModalComponent, EditTpnOpenBatchModalComponent, InformationModalComponent, JumpToButtonsComponentComponent, 
     DynamicFormComponentComponent, DownloaderLoaderComponent, SetUpRecurringPaymentFormComponent, IsoLogoUploadComponent, BackButtonComponent, RefreshButtonComponent, HighlightPipe,
    CapitalizePipe, HelperTooltipComponent, ProcessorDataFormComponentComponent,
    IntegerOnlyDirective, ZipFormatDirective, SanitizerUrlPipe,CardModalWidgetComponent, CardComponent,
    ValueOrNaPipe, AppTwoDIgitDecimalNumberDirective, ToDollarsPipe, ToAmountPipe, AchProcessorDataComponent, ReactiveFormDynamicErrorMessageComponent, RibbonComponent, IlustrationWithMessageComponent, ZipCodeComponent, DollarsToCents, ArrayToValues, EmailChangeModalComponent,CustomSelectFilterComponent, WoocommerceSettingsComponent,TermsAndconditionComponent,TransactionDataPipe,DatePickerComponent, MerchantBillingDialogComponent,LoginAsModalComponent,PayaAchComponent,MultiFactorAuthComponent,AutoScrollbarHeightDirective, DynamicFormGroupComponent, NotesComponent, InventoryRegisterLiteSettingsComponent, VericheckAchComponent, IsvApplicationDialogComponent, IsvTagDialogComponent, FileDropzoneComponent, PageBreadcrumbComponent, FileStatusModalComponent, ToastProgressComponent],
  imports: [
    CommonModule,
    SharedRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    DividerModule,
    InputNumberModule,
    NgbModule,
    ToastModule,
    TranslateModule,
    NgSelectModule,
    NgxMaskModule,
    NgxDropzoneModule,
    SelectButtonModule,
    InputTextModule,
    CheckboxModule,
    FileUploadModule,
    FieldsetModule,
    RadioButtonModule,
    UiSwitchModule,
    MessageModule,
    datePipeModule,
    DropdownModule,
    PerfectScrollbarModule,
    FeahterIconModule,
    ListboxModule,
    ButtonModule,
    TableModule,
    NgxTrimDirectiveModule,
    AccordionModule,
    NgxUiLoaderModule,
    NgApexchartsModule,
    ZingchartAngularModule,
    ChipsModule,
    InputSwitchModule,
    InputTextModule,
    TooltipModule,
    SkeletonModule,
    ProgressBarModule,
    // AuthModule
  ],
  exports: [LoadingComponent,
    DashboardComponent,
    SearchBoxFilterComponent,
    SafeHtmlPipe,
    SanitizerUrlPipe,
    TransactionDataPipe,
    JumpToButtonsComponentComponent,
    IsoLogoUploadComponent,
    BackButtonComponent,
    RefreshButtonComponent,
    CapitalizePipe,
    HelperTooltipComponent,
    ProcessorDataFormComponentComponent,
    ValueOrNaPipe,
    AppTwoDIgitDecimalNumberDirective,
    AchProcessorDataComponent,
    ToDollarsPipe,
    ToAmountPipe,
    IntegerOnlyDirective,
    ZipFormatDirective,
    ReactiveFormDynamicErrorMessageComponent,
    RibbonComponent,
    IlustrationWithMessageComponent,
    DollarsToCents,
    ArrayToValues,
    CardModalWidgetComponent,
    CardComponent,
    CustomSelectFilterComponent,
    WoocommerceSettingsComponent,
    TermsAndconditionComponent,
    AutoScrollbarHeightDirective,
    DatePickerComponent,
    DynamicFormComponentComponent,
    MerchantBillingDialogComponent,
    LoginAsModalComponent,
    PayaAchComponent,
    MultiFactorAuthComponent,
    NotesComponent,
    TooltipModule,
    InventoryRegisterLiteSettingsComponent,
    VericheckAchComponent,
    FileDropzoneComponent,
    PageBreadcrumbComponent,
    FileStatusModalComponent,
    ToastProgressComponent
  ],
  providers: [
      MessageService,DatePickerComponent
    ]
})
export class SharedModule { }